// @core/api/endpoints/attachment/get_ownership_history.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetOwnershipHistoryResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get attachment ownership history
 * Returns a paginated audit trail of all ownership changes for an attachment including previous owners, transfer reasons, and timestamps.
 */
export async function GetOwnershipHistory(
  attachment_id: string,
  options?: RequestOptions
): Promise<GetOwnershipHistoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id/ownership-history`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.get<GetOwnershipHistoryResponse>(requestPath, { ...requestOptions });
}
